import { Form } from 'react-bootstrap'
import { ConfigProvider, Select } from 'antd'

export default function MultiSelectBox(props) {

    const { label_name, placeholder, disabled, closeMenu, option, filterOption, name, defaultValue, onChange, onBlur, error, loading, reference, onInputChange, form_group, onClear, mandatory, customOption, value, tabIndex } = props

    return (
        <>
            <Form.Group className={form_group ? form_group : "mb-2"} controlId="">
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}

                <ConfigProvider
                    theme={{
                        components: {
                            Select: {
                                activeOutlineColor: 'rgba(0, 105, 114, 0.2)',
                                optionSelectedColor: '#0F172A',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            fontFamily: 'Inter'
                        },
                    }}
                >
                    <Select
                        ref={reference}
                        showSearch
                        // allowClear
                        size='medium'
                        mode="multiple"
                        // className='antd_custom_select'
                        placeholder={placeholder}
                        disabled={disabled}
                        loading={loading}
                        options={option}
                        optionRender={customOption}
                        filterOption={filterOption}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onSearch={onInputChange}
                        // onFocus={onChange}
                        onBlur={onBlur}
                        // onClear={onClear}
                        tabIndex={tabIndex}
                        getPopupContainer={(trigger) => trigger.parentNode}

                        style={{
                            width: '100%',
                        }}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
